import { type Locale } from "next-intl";
import { getPathname } from "./navigation";
import { locales } from "@/config";


export type Href = Parameters<typeof getPathname>[0]["href"];


export function getAbsoluteUrl(locale: Locale, href: Href) {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL ?? "";
  const pathname = getPathname({ locale, href });
  return `${baseUrl}${pathname}`;
};


export function getAlternates(locale: Locale, href: Href) {
  return {
    canonical: getAbsoluteUrl(locale, href),
    languages: Object.fromEntries(
      locales.map(locale => [locale, getAbsoluteUrl(locale, href)])
    ),
  }
};
